import { LocalizedMatchWithSimplifiedNews } from "../../../types/match"
import { Col, Row } from "react-bootstrap"
import { PredictionMatchRow } from "@components/Predictions/PredictionMatchRow"
import { useMemo } from "react"
import moment from "moment"
import "moment/locale/it"
import * as LanguageConstants from "../../../constants/languages"
import { orderBy } from "lodash"
import { ColProps } from "react-bootstrap/Col"

moment.locale(LanguageConstants.DEFAULT_LOCALE)

export const PredictionMatchList = ({
  matchWithNewsList,
  col,
}: {
  matchWithNewsList: LocalizedMatchWithSimplifiedNews[]
  col?: ColProps
}) => {
  const dates = useMemo(() => {
    return [
      ...new Set(
        matchWithNewsList.filter((m) => m.match.date).map((m) => moment(m.match.date)?.format("DD MMMM YYYY")),
      ),
    ]
  }, [matchWithNewsList])

  return (
    <Col className={`prediction-match-list-cc`} {...col}>
      {dates.map((date, i) => {
        const filteredMatchWithNewsList = orderBy(
          matchWithNewsList.filter((m) => moment(m.match.date).format("DD MMMM YYYY") === date),
          (m) => {
            return moment(m.match.date).format("YYYYMMDD")
          },
          ["asc"],
        )

        return (
          <Row key={`date-${i}`} className="prediction-match-row-container">
            <Col xs={12}>
              <Col className={"date-col d-flex"} xs={12}>
                <div className={"date"}>{date}</div>
                <div className={"date-border"}></div>
              </Col>
              <Col xs={12}>
                {filteredMatchWithNewsList.map((matchWithNews, i) => {
                  return (
                    <Row key={i} className={"g-0"}>
                      <PredictionMatchRow matchWithNews={matchWithNews} />
                    </Row>
                  )
                })}
              </Col>
            </Col>
          </Row>
        )
      })}
    </Col>
  )
}
